import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faWhatsapp,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useTranslate } from "../../context/TranslationContext";
import "./style.css";

const ShareModal = ({
  show,
  onHide,
  t: translate,
  shareUrl = window.location.href,
  copyUrl = shareUrl,
  themeVars,
}) => {
  const { t: defaultTranslate } = useTranslate("instructorDetails");
  const t = translate || defaultTranslate;
  const openShare = (url) => window.open(url, "_blank", "noopener,noreferrer");
  const encodedUrl = encodeURIComponent(shareUrl);
  const shareWhatsapp = () => openShare(`https://wa.me/?text=${encodedUrl}`);
  const shareFacebook = () =>
    openShare(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`);
  const shareLinkedIn = () =>
    openShare(
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    );
  const shareTwitter = () =>
    openShare(`https://twitter.com/intent/tweet?url=${encodedUrl}`);

  const handleCopyShareLink = async () => {
    try {
      await navigator.clipboard.writeText(copyUrl);
      toast.success(t("copySuccess"));
    } catch {
      toast.error(t("copyError"));
    }
  };

  const shareInstagram = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      window.location.href = "instagram://app";
      setTimeout(() => openShare("https://www.instagram.com/"), 1000);
    } catch {
      toast.error(t("copyError"));
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="instructor-share-modal"
      dialogClassName="share-modal"
      style={themeVars}
    >
      <Modal.Header closeButton closeButtonClassName="auto-theme-text">
        <Modal.Title className="auto-theme-text">{t("sharePost")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="share-modal-subtitle">{t("sharePostSubtitle")}</div>

        <div className="share-options">
          <button className="share-card whatsapp" onClick={shareWhatsapp}>
            <div className="share-icon">
              <FontAwesomeIcon icon={faWhatsapp} />
            </div>
            <span>{t("whatsapp")}</span>
          </button>

          <button className="share-card facebook" onClick={shareFacebook}>
            <div className="share-icon">
              <FontAwesomeIcon icon={faFacebook} />
            </div>
            <span>{t("facebook")}</span>
          </button>

          <button className="share-card instagram" onClick={shareInstagram}>
            <div className="share-icon">
              <FontAwesomeIcon icon={faInstagram} />
            </div>
            <span>{t("instagram")}</span>
          </button>

          <button className="share-card linkedin" onClick={shareLinkedIn}>
            <div className="share-icon">
              <FontAwesomeIcon icon={faLinkedin} />
            </div>
            <span>{t("linkedin")}</span>
          </button>

          <button className="share-card twitter" onClick={shareTwitter}>
            <div className="share-icon">
              <FontAwesomeIcon icon={faXTwitter} />
            </div>
            <span>{t("twitter")}</span>
          </button>
        </div>

        <button className="site-btn w-100 mt-3" onClick={handleCopyShareLink}>
          <FontAwesomeIcon icon={faCopy} /> <span>{t("copyText")}</span>
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default ShareModal;
